const loadDealById = async (_token, _id, _func) => {};

const loadDealsByType = async (_token, _status, _func, _page) => {};

const loadDealsCountInitData = async (_token, _func) => {};

const loadProfileInitData = async (_token, _func) => {};

export {
  loadDealById,
  loadDealsByType,
  loadDealsCountInitData,
  loadProfileInitData,
};
